import React, { useEffect } from "react";
import { Alert, Button, Grid, Stack, Typography } from "@mui/material";
import {
  RegistrationCard,
  FruitifyContainer,
} from "../../../../shared-components/Containers";
import FruitifyLogo from "../../../../shared-components/FruitifyLogo";
import { useAuthenticationStore } from "../../../../stores/auth";
import { useTrackingAnalytics } from "../../../../hooks/useTrackingAnalytics";

const PlanCard = ({ subscriptionPlan, onCheckoutClicked }) => {
  const formattedPrice = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(subscriptionPlan.price);

  return (
    <RegistrationCard
      variant="outlined"
      sx={{
        minWidth: "100%",
        display: "flex",
        flexDirection: "column",
        height: "100%", // make all cards equal height
        justifyContent: "space-between", // space out content
        p: 2,
      }}
    >
      <div>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <FruitifyLogo />
        </div>
        <Typography
          component="h2"
          variant="h5"
          sx={{
            width: "100%",
            fontSize: "clamp(1.5rem, 5vw, 1.8rem)",
            mb: 1,
            textAlign: "center",
          }}
        >
          {subscriptionPlan.name}
        </Typography>
        <Typography
          variant="h6"
          sx={{ width: "100%", textAlign: "center", mb: 2 }}
        >
          {formattedPrice} / month
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {subscriptionPlan.description}
        </Typography>
        <Typography variant="subtitle2" sx={{ mb: 2 }}>
          Plan Features
        </Typography>
        {subscriptionPlan.features.map((feat, index) => (
          <Stack
            key={index}
            direction={"row"}
            spacing={2}
            alignItems={"center"}
            sx={{ mb: 1 }}
          >
            <FruitifyLogo width={25} />
            <Typography variant="body1">{feat.feature}</Typography>
          </Stack>
        ))}
      </div>
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={() => onCheckoutClicked(subscriptionPlan.stripePriceId)}
      >
        Subscribe
      </Button>
    </RegistrationCard>
  );
};

export default function Unsubscribed({
  handleStripeCheckout,
  subscriptionPlans,
}) {
  const { user } = useAuthenticationStore();
  const { recordMarketingEvent } = useTrackingAnalytics();

  useEffect(() => {
    recordMarketingEvent("unsubscribed", {}, true);
  }, []);

  return (
    <FruitifyContainer
      data-testid={"unsubscribed-page"}
      sx={{ alignItems: "center", px: 2 }}
    >
      <Typography
        component="h1"
        variant="h4"
        sx={{
          width: "100%",
          textAlign: "center",
          fontSize: "clamp(2rem, 6vw, 2.15rem)",
          mb: 4,
        }}
      >
        Available plans
      </Typography>

      <Grid
        container
        spacing={2}
        direction={"row"}
        justifyContent="center"
        alignItems="stretch" // ensures equal height
      >
        {subscriptionPlans.map((plan, index) => (
          <Grid key={index} size={{ sm: 12, xs: 12, md: 6 }} display="flex">
            <PlanCard
              subscriptionPlan={plan}
              onCheckoutClicked={handleStripeCheckout}
            />
          </Grid>
        ))}
      </Grid>

      {user.info.subscriptionStatus === "incorrect school email" && (
        <Alert sx={{ mt: 4 }} variant={"warning"}>
          Your school appears to have a direct subscription. Make sure to use
          your school email or contact your administrator.
        </Alert>
      )}
    </FruitifyContainer>
  );
}
